require('./index.scss');
const AgStat = require('public/ag_statv2');
var _gameid = $('#_gameid').val();
var _gamename = $('#_gamename').val();
var _pagemodule = $('#_pagemodule').val();
var _hasPkg = $('#_hasPkg').val();

if (_pagemodule && _gameid && _gamename) {
  // 非专区的情况下不出发打点逻辑
  const ag_stat = new AgStat(_pagemodule, {
    ag_field: 'gameid',
    ag_value: _gameid,
    ag_a7: _gamename,
    ag_a8: _hasPkg,
  });
}

class PcGameZoneModule {
  constructor() {
    this.GrTanchuan();
    this.createQrcode();
    this.showMore();
  }

  // pc GR事项弹窗相关代码
  GrTanchuan() {
    if ($('#ng_game_xiaxian').length > 0) {
      $('#ng_game_xiaxian').on('click', (e) => {
        $('.xiaxian-mask').removeClass('hide');
      });
      $('.xiaxian-close').on('click', (e) => {
        $('.xiaxian-mask').addClass('hide');
      });
      // 待补充具体每个游戏的链接
      // xMan_qrcode 是引用js中生成qrcode方法
      const qrTxt = $('#ng_game_xiaxian').data('href');
      const qrcode = window.xMan_qrcode({
        render: 'canvas',
        width: 120,
        height: 120,
        correctLevel: 0,
        text: qrTxt,
      });
      $('#xiaxian-qrcode').append(qrcode);
    }
  }

  createQrcode() {
    $('.JS_qrcode_game_down').each((idx, elem) => {
      const gameId = $(elem).data('gameid');
      const ch = $(elem).data('ch');
      const r = $(elem).data('width') || 140;
      const url = $(elem).data('url');
      let downUrl = '';
      if (ch && ch.length > 0) {
        downUrl = 'https://render-se.9game.cn/p/r/66ebe990a7493b10d5223074/index?pageType=game_detail&ch=' + ch + '&gameId=' + gameId + '&pullUpFrom=ugt_game_highspeed_' + gameId + '&opt=download';
        if (parseInt(gameId, 10) === 79532) {
          downUrl = 'https://render-se.9game.cn/p/r/66ebe990a7493b10d5223074/index?pageType=home&ch=' + ch;
        }
      } else {
        downUrl = url;
      }
      const qrcode = window.xMan_qrcode({
        render: 'canvas',
        width: r,
        height: r,
        correctLevel: 0,
        text: downUrl,
      });
      $(elem).append(qrcode);
      $(elem).addClass('show');
    });
  }

  showMore() {
    // 礼包详情显示
    $('.ngame-dws').delegate('.more', 'mouseenter', function() {
      $(this).children('.tips').show();
    });
    $('.ngame-dws').delegate('.more', 'mouseleave', function() {
      $(this).children('.tips').hide();
    });
  }
}

new PcGameZoneModule();

/* eslint-disable */
/*替换用户信息板块*/
function replaceUserInfo(data) {
  // 参数校验
  if (data == null || data.uid == null || data.uid <= 0) {
    return;
  }
  // 变量定义
  var memberUrl = "https://myspace.9game.cn/";
  var memberCss = "";
  if (data.member != null && data.member.memberType != null && data.member.memberType == 1 && data.member.memberGrade > 0) {
    memberUrl = "https://huiyuan.9game.cn/";
    memberCss = "vip link vip" + data.member.memberGrade;
  }

  // 开始替换
  var userInfoBlock = $("li#ajaxLogin");
  var userMsgBlock = $("li#ajaxRegister");
  var userInfoHtml = $("li#ajaxUserInfo");
  var userMsgHtml = $("li#ajaxMsg");
  var userLoginSign = $("#login");

  userInfoBlock.attr("class", userInfoHtml.attr("class"));
  userMsgBlock.attr("class", userMsgHtml.attr("class"));
  userLoginSign.attr("value", 1);

  $("img[ajaxName=userLogo]").attr("src", data.logoImgSrc);
  $("a[ajaxName=userName]").attr("class", memberCss);
  $("a[ajaxName=userName]").attr("href", memberUrl);
  $("a[ajaxName=userName]").text(data.nickName);
  $("span[ajaxName=msgNum]").text(data.msg.msgNum);
  $("span[ajaxName=sysMsgNum]").text(data.msg.sysMsgNum);
  $("span[ajaxName=actMsgNum]").text(data.msg.actMsgNum);
  $("span[ajaxName=ghMsgNum]").text(data.msg.ghMsgNum);
  $("span[ajaxName=kaMsgNum]").text(data.msg.kaMsgNum);
  $("span[ajaxName=bbsMsgNum]").text(data.msg.bbsMsgNum);
  $("span[ajaxName=dialogMsgNum]").text(data.msg.dialogMsgNum);
  $("span[ajaxName=imMsgNum]").text(data.msg.imMsgNum);

  userInfoBlock.html(userInfoHtml.html());
  userMsgBlock.html(userMsgHtml.html());
}

/* 异步获取用户登录信息 */
window.onload = function () {
  $.ajax({
    url: window.location.origin + "/tpl/pc2/ajaxinfo/ajax_login_info.html",
    type: 'POST',
    timeout: 15e3,
    data: null,
    success: function (data, state) {
      if (data != null && data.uid != null && data.uid > 0) {
        replaceUserInfo(data);
      }
    },
    dataType: "json"
  });
}



// WEBPACK FOOTER //
// ./jws/views/page/pc_gamezone/index.js